webpackJsonp([2],{

/***/ 30:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Landing_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Landing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Landing_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Main_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Main_vue__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: "/",
    name: "Landing",
    component: __WEBPACK_IMPORTED_MODULE_2__Landing_vue___default.a
  }, {
    path: "/game",
    name: "Main",
    component: __WEBPACK_IMPORTED_MODULE_3__Main_vue___default.a
  }]
}));

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(100);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var initialState = function initialState() {
  return {};
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: initialState
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(88),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return en; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return th; });
var en = [{
  title: "Add some text to screen, set the background, and log to the console.",
  text: "First of all, we're going to <b>add some text</b> to the screen.\n      You instruct the computer to do stuff by using <b>functions</b>.\n      We can put our instructions in the <b>create</b> function,\n      and it will be run when the game is created. Let's try it out!\n      <br><br>\n      You can use the addText function like this: <code>addText(50, 50, \"Hello World\", \"60px\", \"white\")</code>\n      This will add a huge white text at the upper-left corner (x is 50 and y is 50).\n      <br><br>\n      You can <b>set the background</b> with <code>setBackground(color)</code>,\n      with color names such as \"teal\", or color codes like \"#2ecc71\" as the parameter.\n      <br><br>\n      What if you wanted to know what is going on in your program?\n      You could always use the <b>friendly log viewer</b> on the bottom right.\n      You can view the errors, and also <b>print out the value</b> of a\n      variable with the log function, like this: <code>log(\"Hi!\")</code>\n    "
}, {
  title: "Add a Brick",
  text: "You're doing a pretty good job! Next, we're going to be creating a brick.\n    <br><br>\n    First, we've created a blank function for you, and it's called <b>addBricks</b>.\n    You'll want to put the code responsible for adding a brick in this function,\n    so it'll be easier to reuse.\n    <br><br>\n    We're going to create a brick variable, and assign it to the result of the\n    <b>bricks.create</b> function, which takes the x and y coordinates, the\n    image set, and then the image.\n    <br><br>\n    Note that the image is 36 in height and 52 in width, so we have to add that\n    to our coordinates, in addition to the 10px spacing to give it more room to breathe.\n    You could use something like <code>spacing + (x * 36)</code> or <code>spacing + (y * 52)</code>\n    <br><br>\n    Also, we have 5 variations of brick image files, from \"brick_1_1.png\" to \"brick_5_1.png\".\n    Feel free to play with all the different images!\n\n    <code>\n      <pre>\n// You create a variable by using the \"const\" keyword, then set it to something.\n// Create a brick in the specified coordinates, then use the brick image.\n\n// Replace the variables to your likings.\n// width and height is a number, and the image is the file name.\n// const brick = bricks.create(width, height, \"breakout\", image)\n\n// This makes the brick bouncy and not movable.\nbrick.body.bounce.set(1)\nbrick.body.immovable = true</pre></code>\n\n    After that, <b>don't forget</b> to use the <b>addBricks()</b> function you've just made!\n    You can simply put <code>addBricks()</code> in the end of the <code>create</code> function.\n\n    "
}, {
  title: "Add Walls of Bricks",
  text: "Here comes the interesting part. We're going to place a wall with many bricks!\n    <br>\n    However, it's super tedious to copy and paste all the rows and columns and change\n    the placements, so we're gonna make the computer go through that for us.\n    <br><br>\n    You can continue working in the addBricks() function.\n    Since the wall is composed of rows and columns of bricks, we can use a loop\n    to go through those and place the bricks for us. Here's how a loop works:\n\n    <code>\n      <pre>\nfor (let i = 0; i <= 100; i++) {\nconsole.log(\"Hey! I am Number\", i)\n}</pre></code>\n\n    This will log the number from 0 to 100. All you need to do is to create a\n    variable for the starting number (<code>let i = 0;</code>),\n    see when it should end (<code>i <= 100;</code>),\n    and add the variable by one everytime.\n    <br><br>\n    However, the wall can be too close to others. We can add a little more padding\n    by positioning them a bit further away. Here's how you might do it:\n\n    <code>\n      <pre>\nx = padding + (row * imageSize)\ny = padding + (col * imageSize)</pre></code>\n\n    Hint Hint: You can place two loops together! If you're not sure, you can use\n    the logger to log the positions. Just use the <code>console.log()</code> function.\n    "
}, { title: "Randomize the Brick's Colors" }, { title: "Add a Paddle and Make it Move!" }, { title: "Add Stationary Ball" }, { title: "Release the Ball (& Input Bind)" }, { title: "Ball Hit Paddle and Bounce (Collision)" }, { title: "Ball Hit Brick (& Destroy Bricks)" }];

var th = [{
  title: "Add some text to screen, set the background, and log to the console.",
  text: "\u0E40\u0E23\u0E32\u0E21\u0E32\u0E40\u0E23\u0E34\u0E48\u0E21 Coding \u0E01\u0E31\u0E19\u0E04\u0E23\u0E31\u0E1A \u0E01\u0E48\u0E2D\u0E19\u0E08\u0E30\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E01\u0E21 \u0E40\u0E23\u0E32\u0E21\u0E32\u0E17\u0E1A\u0E17\u0E27\u0E19\u0E01\u0E31\u0E19\u0E01\u0E48\u0E2D\u0E19\n\n\u0E02\u0E2D\u0E43\u0E2B\u0E49\u0E19\u0E49\u0E2D\u0E07 \u0E46 \u0E40\u0E02\u0E35\u0E22\u0E19 addText function \u0E42\u0E14\u0E22\u0E17\u0E35\u0E48\u0E21\u0E35 \u0E1E\u0E32\u0E23\u0E32\u0E21\u0E35\u0E40\u0E15\u0E2D\u0E23\u0E4C \u0E15\u0E31\u0E27\u0E41\u0E23\u0E01\u0E1A\u0E2D\u0E01\u0E2A\u0E48\u0E27\u0E19\u0E2A\u0E39\u0E07  \u0E15\u0E31\u0E27\u0E2A\u0E2D\u0E07\u0E1A\u0E2D\u0E01\u0E04\u0E27\u0E32\u0E21\u0E01\u0E27\u0E49\u0E32\u0E07 \u0E15\u0E31\u0E27\u0E2A\u0E32\u0E21\u0E1A\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E17\u0E35\u0E48\u0E08\u0E30\u0E43\u0E2B\u0E49\u0E1E\u0E34\u0E21\u0E1E\u0E4C \u0E15\u0E31\u0E27\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48\u0E1A\u0E2D\u0E01\u0E02\u0E19\u0E32\u0E14 \u0E41\u0E25\u0E30\u0E15\u0E31\u0E27\u0E17\u0E35\u0E48\u0E2B\u0E49\u0E32\u0E1A\u0E2D\u0E01\u0E2A\u0E35 \u0E40\u0E0A\u0E48\u0E19 addText(50, 50, \"Hello World\", \"60px\", \"white\")\n\n\u0E41\u0E25\u0E30\u0E02\u0E2D\u0E43\u0E2B\u0E49\u0E19\u0E49\u0E2D\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E2A\u0E35\u0E02\u0E2D\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E35 \u0E40\u0E02\u0E35\u0E22\u0E27\u0E2D\u0E21\u0E19\u0E49\u0E33\u0E40\u0E07\u0E34\u0E19 \u201Cteal\u201D \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49 setBackground(_).\n    "
}, {
  title: "Add Walls of Bricks",
  text: "\u0E40\u0E01\u0E48\u0E07\u0E21\u0E32\u0E01\u0E19\u0E49\u0E2D\u0E07 \u0E02\u0E2D\u0E43\u0E2B\u0E49\u0E17\u0E33\u0E15\u0E48\u0E2D\u0E44\u0E1B\n\n\u0E21\u0E32\u0E40\u0E23\u0E34\u0E48\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E01\u0E31\u0E19\u0E40\u0E25\u0E22 \u0E17\u0E35\u0E21\u0E07\u0E32\u0E19\u0E40\u0E23\u0E32\u0E21\u0E35\u0E2A\u0E23\u0E49\u0E32\u0E07 Function \u0E43\u0E2B\u0E49\u0E19\u0E49\u0E2D\u0E07 \u0E46 \u0E43\u0E0A\u0E49 \u0E04\u0E37\u0E2D addBricks(_)\n\n\u0E40\u0E23\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E19\u0E49\u0E2D\u0E07\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E15\u0E31\u0E27\u0E41\u0E1B\u0E25\u0E0A\u0E37\u0E48\u0E2D\u0E27\u0E48\u0E32 brick \u0E01\u0E48\u0E2D\u0E19 \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49 bricks.create(width, height, \"breakout\", image)\n\n\u0E17\u0E35\u0E21\u0E07\u0E32\u0E19\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E2A\u0E48\u0E27\u0E19\u0E2A\u0E39\u0E07 36 px \u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27 52 px \u0E41\u0E25\u0E30\u0E40\u0E15\u0E34\u0E21\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E02\u0E2D\u0E07 brick 10 px \u0E41\u0E25\u0E30\u0E43\u0E0A\u0E48 \u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E\u0E2B\u0E49\u0E32\u0E41\u0E1A\u0E1A \u201Cbrick_1_1.png\u201D \u0E42\u0E14\u0E22\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E15\u0E31\u0E27\u0E40\u0E25\u0E02 \u201C1_1\u201D to \u201C5_1\u201D.\n\n\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E43\u0E2B\u0E49\u0E04\u0E34\u0E14\u0E2B\u0E32\u0E27\u0E34\u0E18\u0E35\u0E40\u0E15\u0E34\u0E21 Brick \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49 loop\n\u0E19\u0E35\u0E49\u0E04\u0E37\u0E2D\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\n\n<code>\n  <pre>\nfor (let i = 0; i <= 100; i++) {\nconsole.log(\"Hey! I am Number\", i)\n}</pre></code>\n\n\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E02\u0E49\u0E32\u0E07\u0E1A\u0E19\u0E19\u0E35\u0E49\u0E08\u0E30\u0E1E\u0E34\u0E21\u0E1E\u0E4C 0 \u0E16\u0E36\u0E07 100.\n\n\u0E16\u0E49\u0E32\u0E40\u0E23\u0E32\u0E08\u0E30\u0E40\u0E15\u0E34\u0E21 Brick \u0E2B\u0E25\u0E32\u0E22\u0E41\u0E16\u0E27 \u0E43\u0E2B\u0E49\u0E19\u0E49\u0E2D\u0E07\u0E04\u0E34\u0E14\u0E16\u0E36\u0E07\u0E23\u0E30\u0E22\u0E30\u0E02\u0E2D\u0E07 Bricks \u0E14\u0E49\u0E27\u0E22\u0E40\u0E0A\u0E48\u0E19\n\n<code>\n  <pre>\nx = padding + (row * imageSize)\ny = padding + (col * imageSize)</pre></code>\n\nHint: \u0E19\u0E49\u0E2D\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E2A\u0E48 for loop \u0E43\u0E19\u0E2D\u0E35\u0E01 for loop \u0E44\u0E14\u0E49!"
}, { title: "Randomize the Brick's Colors" }, { title: "Add a Paddle and Make it Move!" }, { title: "Add Stationary Ball" }, { title: "Release the Ball (& Input Bind)" }, { title: "Ball Hit Paddle and Bounce (Collision)" }, { title: "Ball Hit Brick (& Destroy Bricks)" }];

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_shortkey__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(31);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_shortkey___default.a);

window.$vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_3__routes__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: "<App />",
  components: { App: __WEBPACK_IMPORTED_MODULE_2__components_App___default.a }
});

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app"
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_ace_editor__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_ace_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_ace_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_ace_editor_node_modules_brace_mode_javascript__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_ace_editor_node_modules_brace_mode_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_ace_editor_node_modules_brace_mode_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_ace_editor_node_modules_brace_theme_tomorrow__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_ace_editor_node_modules_brace_theme_tomorrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_ace_editor_node_modules_brace_theme_tomorrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_ace_editor_node_modules_brace_ext_language_tools__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_ace_editor_node_modules_brace_ext_language_tools___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_ace_editor_node_modules_brace_ext_language_tools__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_ace_editor_node_modules_brace_ext_searchbox__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_ace_editor_node_modules_brace_ext_searchbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_ace_editor_node_modules_brace_ext_searchbox__);










var initialCode = "/*\n  Welcome to Code4Fun!\n\n  This is the Code Editor, where magic happens.\n  We're going to create our first breakout game!\n\n  Instructions are in the Task menu on the left.\n*/\n\n// Function for adding in brick(s).\nfunction addBricks() {\n  // Replace the variables to your likings.\n  // width and height is a number, and the image is the file name.\n\n  // const brick = bricks.create(width, height, \"breakout\", image)\n\n  // This makes the brick bouncy and not movable.\n\n  // brick.body.bounce.set(1)\n  // brick.body.immovable = true\n}\n\n// Runs when the game is created\nfunction create() {\n  init()\n}\n\n// Runs everytime the game is updated.\nfunction update() {\n\n}\n\n// This will start the game.\nstart()\n";

var exampleCode = "\nfunction addBricks(padding, x = 1, y = 1) {\n  // Replace the variables to your likings.\n  // width and height is a number, and the image is the file name.\n  // const brick = bricks.create(width, height, \"breakout\", image)\n\n  // This makes the brick bouncy and not movable.\n  brick.body.bounce.set(1)\n  brick.body.immovable = true\n}\n\nfunction create() {\n  init()\n\n  addText(50, 50, \"Hello World\", \"60px\", \"white\")\n  setBackground(\"teal\")\n\n  addBricks(20)\n}\n\n";

var completedCode = "/*\n  Welcome to Code4Fun!\n\n  This is the Code Editor, where magic happens.\n  We're going to create our first breakout game!\n\n  Instructions are in the Task menu on the left.\n*/\n\n// Function for adding in brick(s).\n\nfunction addBricks() {\n  const rows = 4\n  const columns = 16\n\n  for (let y = 0; y < rows; y += 1) {\n    for (let x = 0; x < columns; x += 1) {\n      const posX = 120 + (x * 36)\n      const posY = 100 + (y * 52)\n      const type = `brick_${y + 1}_1.png`\n\n      brick = bricks.create(posX, posY, \"breakout\", type)\n      brick.body.bounce.set(1)\n      brick.body.immovable = true\n    }\n  }\n}\n\n// What should happen if we launches the ball off the paddle?\n\nfunction releaseBall() {\n  if (ballOnPaddle) {\n    ballOnPaddle = false\n    setVelocity(75, 300)\n    ball.animations.play(\"spin\")\n    introText.visible = false\n  }\n}\n\n// What should we do if the ball hit a brick?\n\nwindow.ballHitBrick = function(ball, brick) {\n  brick.kill()\n  score += 10\n  scoreText.text = `Score: ${score}`\n\n  // Are they any bricks left?\n  if (bricks.countLiving() === 0) {\n    // New level starts\n    score += 1000\n    scoreText.text = `Score: ${score}`\n    introText.text = \"- Next Level -\"\n\n    // Let\"s move the ball back to the paddle\n    ballOnPaddle = true\n    ball.body.velocity.set(0)\n    moveBall(paddle.x + 16, paddle.y - 16)\n    ball.animations.stop()\n\n    //  And bring the bricks back from the dead :)\n    bricks.callAll(\"revive\")\n  }\n}\n\n// What should we do if the ball goes back and land on the paddle?\n\nwindow.ballHitPaddle = function(ball, paddle) {\n  let diff = 0\n\n  if (ball.x < paddle.x) {\n    //  Ball is on the left-hand side of the paddle\n    diff = paddle.x - ball.x\n    ball.body.velocity.x = (-10 * diff)\n  } else if (ball.x > paddle.x) {\n    //  Ball is on the right-hand side of the paddle\n    diff = ball.x - paddle.x\n    ball.body.velocity.x = (10 * diff)\n  } else {\n    //  Ball is perfectly in the middle\n    //  Add a little random X to stop it bouncing straight up!\n    ball.body.velocity.x = 2 + (Math.random() * 8)\n  }\n}\n\nfunction movePaddle() {\n  paddle.x = game.input.x\n\n  if (paddle.x < 24) {\n    paddle.x = 25\n  } else if (paddle.x > game.width - 24) {\n    paddle.x = game.width - 24\n  }\n}\n\nfunction create() {\n  init()\n\n  addBricks()\n  addPaddle()\n  addBall()\n\n  addIntroText()\n\n  // Trigger releaseBall on Input\n  game.input.onDown.add(releaseBall, this)\n}\n\nfunction update() {\n  movePaddle()\n  handleBallOnPaddleCollision()\n}\n\n// This will start the game.\nstart()\n\n";

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      code: initialCode,
      cmd: "",
      logs: [{
        text: "$ Hey! Here is where your friendly logs and errors live~!"
      }]
    };
  },
  mounted: function mounted() {
    window.log = this.log;
    window.cheat = this.cheat;
    window.reset = this.reset;
    window.save = this.save;
    window.load = this.load;
  },

  components: {
    editor: __WEBPACK_IMPORTED_MODULE_1_vue2_ace_editor___default.a
  },
  methods: {
    init: function init() {
      var editor = this.$refs.editor.editor;

      editor.setOptions({
        fontSize: "1em",
        enableSnippets: true,
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true
      });
    },
    getType: function getType(type) {
      return {
        err: type === "err",
        info: type === "info",
        return: type === "return"
      };
    },
    appendLog: function appendLog(text, type) {
      console.info("APPEND_LOG", { text: text, type: type });
      this.logs = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.logs), [{ text: text, type: type }]);
    },
    log: function log() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.appendLog(args.join(" "));
    },
    run: function run() {
      try {
        var code = this.code;
        code = code.replace("console.log", "window.log");
        code = code.replace(/function (.*)\(\) {/g, "window.$1 = function() {");
        eval(code);
      } catch (err) {
        this.appendLog("> " + err.toString(), "err");
        console.error(err);
      }
    },
    term: function term() {
      try {
        var cmd = this.cmd;
        cmd = cmd.replace("console.log", "window.log");
        var result = eval(cmd);
        this.appendLog(">> " + result, "return");
      } catch (err) {
        this.appendLog(">> " + err.toString(), "err");
        console.error(err);
      }
    },
    cheat: function cheat() {
      this.code = completedCode;
      return "Baka! Cheater!! -//-";
    },
    reset: function reset() {
      this.code = initialCode;
      return "Starting Over. Practice Makes Perfect!";
    },
    save: function save(name) {
      localStorage.setItem("code_" + name, this.code);
      window.log("Saved as code_" + name + ".");
    },
    load: function load(name) {
      var code = localStorage.getItem("code_" + name);
      if (code) {
        window.log("Loaded as code_" + name);
        this.code = code;
      }
    }
  }
});

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pixi_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pixi_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pixi_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_p2__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_p2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_p2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_phaser__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_phaser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_phaser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_tasks__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor_vue__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Editor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Editor_vue__);









window.game = null;
window.ball = null;
window.paddle = null;
window.brick = null;
window.bricks = null;

window.ballOnPaddle = true;

window.lives = 19;
window.score = 0;

window.scoreText = null;
window.livesText = null;
window.introText = null;

window.init = function () {
  game.physics.startSystem(__WEBPACK_IMPORTED_MODULE_2_phaser___default.a.Physics.ARCADE);
  game.physics.arcade.checkCollision.down = false;

  bricks = game.add.group();
  bricks.enableBody = true;
  bricks.physicsBodyType = __WEBPACK_IMPORTED_MODULE_2_phaser___default.a.Physics.ARCADE;
};

window.setVelocity = function (x, y) {
  ball.body.velocity.y = -y;
  ball.body.velocity.x = -x;
};

window.moveBall = function (x, y) {
  ball.x = x;
  ball.y = y;
};

window.random = function (min, max) {
  return Math.floor(Math.random() * (max - min) + min);
};

window.setBackground = function (param) {
  return document.querySelector(".game").style.background = param;
};

window.ballLost = function () {
  lives -= 1;
  livesText.text = "Lives: " + lives;

  if (lives === 0) {
    gameOver();
  } else {
    ballOnPaddle = true;
    ball.reset(paddle.body.x + 16, paddle.y - 16);
    ball.animations.stop();
  }
};

window.gameOver = function () {
  ball.body.velocity.setTo(0, 0);
  introText.text = "Game Over!";
  introText.visible = true;
};

window.addPaddle = function () {
  paddle = game.add.sprite(game.world.centerX, 500, "paddle");
  paddle.anchor.setTo(0.5, 0.5);

  game.physics.enable(paddle, __WEBPACK_IMPORTED_MODULE_2_phaser___default.a.Physics.ARCADE);

  paddle.body.collideWorldBounds = true;
  paddle.body.bounce.set(1);
  paddle.body.immovable = true;
};

window.addBall = function () {
  ball = game.add.sprite(game.world.centerX, paddle.y - 16, "breakout", "ball_1.png");
  ball.anchor.set(0.5);
  ball.checkWorldBounds = true;

  game.physics.enable(ball, __WEBPACK_IMPORTED_MODULE_2_phaser___default.a.Physics.ARCADE);

  ball.body.collideWorldBounds = true;
  ball.body.bounce.set(1);

  ball.animations.add("spin", ["ball_1.png", "ball_2.png", "ball_3.png", "ball_4.png", "ball_5.png"], 50, true, false);

  ball.events.onOutOfBounds.add(ballLost, this);
};

window.addIntroText = function () {
  var whiteFont = { font: "20px Roboto", fill: "#ffffff", align: "left" };

  scoreText = game.add.text(32, 550, "score: 0", whiteFont);
  livesText = game.add.text(680, 550, "lives: " + lives, whiteFont);
  introText = game.add.text(game.world.centerX, 400, "- click to start -", { font: "40px Arial", fill: "#ffffff", align: "center" });
  introText.anchor.setTo(0.5, 0.5);
};

window.addText = function (x, y, text) {
  var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "2.8em";
  var fill = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "#ffffff";
  var align = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "left";
  var font = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "Roboto";

  return game.add.text(x, y, text, { font: size + " " + font, fill: fill, align: align });
};

window.handleBallOnPaddleCollision = function () {
  if (ballOnPaddle) {
    ball.body.x = paddle.x;
  } else {
    game.physics.arcade.collide(ball, paddle, ballHitPaddle, null, this);
    game.physics.arcade.collide(ball, bricks, ballHitBrick, null, this);
  }
};

window.preload = function () {
  game.load.atlas("breakout", "static/games/breakout.png", "static/games/breakout.json");
  game.load.image("paddle", "static/games/paddle.png");
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "phaser",
  data: function data() {
    return {
      game: false,
      task: false,
      taskId: 0,
      tasks: __WEBPACK_IMPORTED_MODULE_3__core_tasks__["a" /* en */]
    };
  },
  components: {
    "code-editor": __WEBPACK_IMPORTED_MODULE_4__components_Editor_vue___default.a
  },
  mounted: function mounted() {
    window.start = this.start;
    window.toEnglish = this.toEnglish;
    window.toThai = this.toThai;
  },

  methods: {
    start: function start() {
      if (window.game) this.reset();

      window.game = new __WEBPACK_IMPORTED_MODULE_2_phaser___default.a.Game("85%", "100%", __WEBPACK_IMPORTED_MODULE_2_phaser___default.a.AUTO, this.$refs.gameview, {
        preload: preload,
        create: create,
        update: update
      }, true);

      this.game = true;
    },
    toEnglish: function toEnglish() {
      this.tasks = __WEBPACK_IMPORTED_MODULE_3__core_tasks__["a" /* en */];
    },
    toThai: function toThai() {
      this.tasks = __WEBPACK_IMPORTED_MODULE_3__core_tasks__["b" /* th */];
    },
    reset: function reset() {
      window.game.destroy();
      window.game = null;

      window.ball = null;
      window.paddle = null;
      window.brick = null;
      window.bricks = null;

      window.ballOnPaddle = true;

      window.lives = 19;
      window.score = 0;

      window.scoreText = null;
      window.livesText = null;
      window.introText = null;
    }
  },
  destroyed: function destroyed() {
    if (window.game) window.game.destroy();
    this.game = false;
  },
  watch: function watch() {
    this.$nextTick(function () {
      window.game.update();
    });
  }
});

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "x-landing"
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Game_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Game_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Game_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    "game-view": __WEBPACK_IMPORTED_MODULE_0__components_Game_vue___default.a
  }
});

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 75:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(74)
  __webpack_require__(75)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(89),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bc4e5558",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(71)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(86),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5315dd19",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(87),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5e3b6318",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(70)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(85),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b0706a8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 85:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('game-view')
},staticRenderFns: []}

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('code-editor'), _c('svg', {
    staticClass: "viewTask",
    attrs: {
      "viewBox": "0 0 32 32"
    },
    on: {
      "click": function($event) {
        _vm.task = !_vm.task
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.42 28.678l-12.433-12.238 6.168-6.071 6.265 6.167 13.426-13.214 6.168 6.071-19.594 19.285zM3.372 16.441l9.048 8.905 16.208-15.953-2.782-2.739-13.426 13.214-6.265-6.167-2.782 2.739z"
    }
  })]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.task),
      expression: "task"
    }],
    staticClass: "tasks"
  }, [_c('div', {
    staticClass: "task-overlay",
    on: {
      "click": function($event) {
        _vm.task = !_vm.task
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "cursor": "pointer"
    }
  }, [_vm._v("["), _c('span', {
    on: {
      "click": function($event) {
        _vm.toEnglish()
      }
    }
  }, [_vm._v("EN")]), _vm._v(" / "), _c('span', {
    on: {
      "click": function($event) {
        _vm.toThai()
      }
    }
  }, [_vm._v("TH")]), _vm._v("]")]), _vm._l((_vm.tasks), function(t, i) {
    return _c('div', {
      staticClass: "task",
      class: {
        'active': _vm.taskId === i
      },
      on: {
        "click": function($event) {
          _vm.taskId = i
        }
      }
    }, [_c('div', {
      staticClass: "task-title"
    }, [_c('svg', {
      attrs: {
        "viewBox": "0 0 32 32"
      }
    }, [_c('path', {
      attrs: {
        "d": "M30.5 24h-0.5v-6.5c0-1.93-1.57-3.5-3.5-3.5h-8.5v-4h0.5c0.825 0 1.5-0.675 1.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5h-5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h0.5v4h-8.5c-1.93 0-3.5 1.57-3.5 3.5v6.5h-0.5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5h-0.5v-6h8v6h-0.5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5h-0.5v-6h8v6h-0.5c-0.825 0-1.5 0.675-1.5 1.5v5c0 0.825 0.675 1.5 1.5 1.5h5c0.825 0 1.5-0.675 1.5-1.5v-5c0-0.825-0.675-1.5-1.5-1.5zM6 30h-4v-4h4v4zM18 30h-4v-4h4v4zM14 8v-4h4v4h-4zM30 30h-4v-4h4v4z"
      }
    })]), _c('b', [_vm._v("Task " + _vm._s(i + 1) + " - " + _vm._s(t.title))])]), (i === _vm.taskId) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(t.text)
      }
    }) : _vm._e()])
  })], 2)]), _c('div', {
    ref: "gameview",
    staticClass: "game"
  }, [(!_vm.game) ? _c('div', {
    staticClass: "blank"
  }, [_vm._m(0)]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('h1', [_vm._v("Let's Get Started!")]), _c('p', [_vm._v("You just have to "), _c('b', [_vm._v("write the code")]), _vm._v("! "), _c('br'), _vm._v("\nFeel free to experiment as your project goes.")]), _c('p', [_vm._v("Begin by completing tasks, which can be accessed "), _c('br'), _vm._v("\nusing the "), _c('b', [_vm._v("Task")]), _vm._v(" button on the lower left.")]), _c('p', [_vm._v("If you want to try out your masterpiece, "), _c('br'), _vm._v("\njust hit that "), _c('b', [_vm._v("Run Code")]), _vm._v(" button on the right.")])])
}]}

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_vm._m(0), _c('main', _vm._l(([1, 2, 3]), function(j) {
    return _c('div', {
      staticClass: "row center-xs"
    }, _vm._l(([1, 2, 3, 4]), function(i) {
      return _c('div', {
        staticClass: "col-xs-12 col-sm-6 col-md-3 cardholder"
      }, [_c('router-link', {
        attrs: {
          "to": "/game"
        }
      }, [_c('div', {
        staticClass: "card"
      }, [_c('header', [_c('svg', {
        attrs: {
          "viewBox": "0 0 32 32"
        }
      }, [_c('path', {
        attrs: {
          "d": "M13.757 19.868c-0.416 0-0.832-0.159-1.149-0.476-2.973-2.973-2.973-7.81 0-10.783l6-6c1.44-1.44 3.355-2.233 5.392-2.233s3.951 0.793 5.392 2.233c2.973 2.973 2.973 7.81 0 10.783l-2.743 2.743c-0.635 0.635-1.663 0.635-2.298 0s-0.635-1.663 0-2.298l2.743-2.743c1.706-1.706 1.706-4.481 0-6.187-0.826-0.826-1.925-1.281-3.094-1.281s-2.267 0.455-3.094 1.281l-6 6c-1.706 1.706-1.706 4.481 0 6.187 0.635 0.635 0.635 1.663 0 2.298-0.317 0.317-0.733 0.476-1.149 0.476z"
        }
      }), _c('path', {
        attrs: {
          "d": "M8 31.625c-2.037 0-3.952-0.793-5.392-2.233-2.973-2.973-2.973-7.81 0-10.783l2.743-2.743c0.635-0.635 1.664-0.635 2.298 0s0.635 1.663 0 2.298l-2.743 2.743c-1.706 1.706-1.706 4.481 0 6.187 0.826 0.826 1.925 1.281 3.094 1.281s2.267-0.455 3.094-1.281l6-6c1.706-1.706 1.706-4.481 0-6.187-0.635-0.635-0.635-1.663 0-2.298s1.663-0.635 2.298 0c2.973 2.973 2.973 7.81 0 10.783l-6 6c-1.44 1.44-3.355 2.233-5.392 2.233z"
        }
      })])]), _c('div', {
        staticClass: "info"
      }, [_c('b', [_vm._v("The Breakout Game")]), _c('p', [_vm._v("Create your very own breakout game from scratch!")])])])])], 1)
    }))
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "header-overlay"
  }), _c('div', {
    staticClass: "header-text"
  }, [_c('h1', [_vm._v("#CODE4ALL")]), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/logo.png"
    }
  }), _c('h2', [_vm._v("เล่นเกมมาเยอะแล้ว มาสร้างเองบ้างสิ!")])])])
}]}

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 89:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['ctrl', 'enter']),
      expression: "['ctrl', 'enter']"
    }],
    staticClass: "pane",
    on: {
      "shortkey": _vm.run
    }
  }, [_vm._m(0), _c('editor', {
    ref: "editor",
    attrs: {
      "lang": "javascript",
      "theme": "tomorrow",
      "width": "100%",
      "height": "100%"
    },
    on: {
      "init": function($event) {
        _vm.init()
      }
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }), _c('button', {
    staticClass: "exec",
    on: {
      "click": _vm.run
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 6l-4-4h-2v2l4 4zM10 0h2v4h-2zM18 10h4v2h-4zM20 4v-2h-2l-4 4 2 2zM0 10h4v2h-4zM10 18h2v4h-2zM2 18v2h2l4-4-2-2zM31.563 27.563l-19.879-19.879c-0.583-0.583-1.538-0.583-2.121 0l-1.879 1.879c-0.583 0.583-0.583 1.538 0 2.121l19.879 19.879c0.583 0.583 1.538 0.583 2.121 0l1.879-1.879c0.583-0.583 0.583-1.538 0-2.121zM15 17l-6-6 2-2 6 6-2 2z"
    }
  })]), _c('span', [_vm._v("Run Code")])]), _c('div', {
    staticClass: "console-wrapper"
  }, [_c('svg', {
    staticClass: "clear",
    attrs: {
      "viewBox": "0 0 32 32"
    },
    on: {
      "click": function($event) {
        _vm.logs = []
      }
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 28h18v4h-18zM28 4h-9.455l-5.743 22h-4.134l5.743-22h-8.411v-4h22zM29.055 32l-4.055-4.055-4.055 4.055-1.945-1.945 4.055-4.055-4.055-4.055 1.945-1.945 4.055 4.055 4.055-4.055 1.945 1.945-4.055 4.055 4.055 4.055z"
    }
  })]), _c('div', {
    staticClass: "console"
  }, _vm._l((_vm.logs), function(log) {
    return _c('div', {
      staticClass: "log",
      class: _vm.getType(log.type)
    }, [_vm._v(_vm._s(log.text))])
  })), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmd),
      expression: "cmd"
    }],
    staticClass: "term",
    domProps: {
      "value": (_vm.cmd)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && $event.keyCode !== 13) { return null; }
        _vm.term($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cmd = $event.target.value
      }
    }
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlebar"
  }, [_vm._v("Code Editor"), _c('div', {
    staticClass: "buttons"
  })])
}]}

/***/ })

},[36]);


// WEBPACK FOOTER //
// static/js/app.2ac518e39960b1d281fe.js